export default "__VITE_ASSET__B6iv6Jqa__"